module.exports = {
	"articleTitle1": "Here's to Vinology, A2's swankiest new wine bar - ",
	"catImage": "greenstar.png",
	"totalCats": 1,
	"name": "Vinology",
	"articleLink1": "https://www.michigandaily.com/content/heres-vinology-a2s-swankiest-new-wine-bar",
	"articleLink2": "https://www.michigandaily.com/opinion/03eric-kukielka-let%E2%80%99s-grab-drink11",
	"articleSnippet1": "Sep 13, 2006 ... The ambiance of Vinology, one of Main Street's latest accoutrements, looks like a \nstripped-down version of a '50s diner. But the interior boasts a ...",
	"articleSnippet2": "Mar 10, 2015 ... Most people are familiar with the bars around campus, so I won't waste time \nextolling the finer virtues of Skeeps over Vinology, or why you ...",
	"foodRecommendations": [],
	"articleTitle2": "Eric Kukielka: Let's grab a drink - ",
	"address": "110 S Main St, Ann Arbor, MI 48104",
	"images": [],
	"position": {
		"lat": 42.281032,
		"lng": -83.748919
	},
	"totalMisc": 0,
	"categories": {
		"fooddrink": 1,
		"location": 1,
		"restaurant": 1
	}
};


//////////////////
// WEBPACK FOOTER
// ./src/json/vinology.json
// module id = 999
// module chunks = 0